import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import { UILabel } from "./UILabel";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { IBuildingBlockControl } from "./BuildingBlockInterfaces";
import type { AppGlueAny } from "../../rule-engine-core/Common/AppGlueAny";

export interface UISwitchProps extends IBuildingBlockControl<AppGlueAny> {
    trueDisplay?: string | ((checked?: boolean) => JSX.Element);
    falseDisplay?: string | ((checked?: boolean) => JSX.Element);
    noColorBackground?: boolean;
    padding?: string;
    paddingTop?: string;
    paddingBottom?: string;
    paddingLeft?: string;
    paddingRight?: string;
}

export function UISwitch(props: UISwitchProps) {
    let f: JSX.Element = <ClearIcon />;

    if (props.falseDisplay) {
        if (props.falseDisplay instanceof String) {
            f = <UILabel variant={"small"}>{props.falseDisplay}</UILabel>;
        } else if (props.falseDisplay instanceof Function) {
            f = props.falseDisplay(props.value);
        }
    }

    let t: JSX.Element = <CheckIcon />;

    if (props.trueDisplay) {
        if (props.trueDisplay instanceof String) {
            f = <UILabel variant={"small"}>{props.trueDisplay}</UILabel>;
        } else if (props.trueDisplay instanceof Function) {
            f = props.trueDisplay(props.value);
        }
    }

    function renderSwitch() {
        return (
            <Box
                style={{
                    margin: props.padding,
                    marginLeft: props.paddingLeft,
                    marginRight: props.paddingRight,
                    marginBottom: props.paddingBottom,
                    marginTop: props.paddingTop,
                }}
                border={"1px solid " + (props.error ? UIStyleConstants.RED_COLOR : UIStyleConstants.GRAY_LIGHTER_COLOR)}
                borderRadius="4pxpx"
                display={"flex"}
                flexDirection={"row"}
                role={"checkbox"}
                height={"31px"}
            >
                <ToggleButtonGroup
                    style={{
                        height: "100%",
                    }}
                    value={props.value}
                    onClick={() => {
                        //                    props.checked = !props.checked;
                        if (props.value !== undefined) props.onChange(!props.value);
                    }}
                >
                    <ToggleButton
                        style={{
                            borderRight: "1px",
                            borderTopLeftRadius: "4px",
                            borderBottomLeftRadius: "4px",
                            borderColor: UIStyleConstants.GRAY_COLOR,
                            background:
                                props.value === false ? UIStyleConstants.RED_LIGHT_COLOR : UIStyleConstants.WHITE_COLOR,
                            paddingRight: "5px",
                            paddingLeft: "5px",
                        }}
                        value={false}
                        onClick={() => {
                            if (props.value === undefined) props.onChange(false);
                        }}
                    >
                        {f}
                    </ToggleButton>
                    <ToggleButton
                        style={{
                            background:
                                props.value === true
                                    ? UIStyleConstants.GREEN_LIGHT_COLOR
                                    : UIStyleConstants.WHITE_COLOR,
                            borderColor: UIStyleConstants.GRAY_COLOR,
                            borderTopRightRadius: "4px",
                            borderBottomRightRadius: "4px",
                            paddingRight: "5px",
                            paddingLeft: "5px",
                        }}
                        value={true}
                        onClick={() => {
                            if (props.value === undefined) props.onChange(true);
                        }}
                    >
                        {t}
                    </ToggleButton>
                </ToggleButtonGroup>
            </Box>
        );
    }

    if (!props.label && !props.hint && !props.error) {
        return renderSwitch();
    } else {
        return (
            <Box
                display={"flex"}
                flexDirection={"column"}
                width={props.fullWidth ? "100%" : undefined}
            >
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={props.label ? "space-between" : "start"}
                    alignItems={"center"}
                    width={"100%"}
                    sx={props.sx}
                >
                    {props.label && <UILabel>{props.label}</UILabel>}
                    {renderSwitch()}
                </Box>
                {(props.error || props.hint) && (
                    <UILabel variant={props.error ? "error_hint" : "hint"}>{props.error ?? props.hint}</UILabel>
                )}
            </Box>
        );
    }
}
